<div
  class="ui-checkbox"
  [class.ui-checkbox--disabled]="isInteractionBlocked()"
  [class.ui-checkbox--locked]="isLocked()"
  [class.ui-checkbox--invalid]="invalid()"
  [class.ui-checkbox--checked]="checked()"
  [class.ui-checkbox--indeterminate]="indeterminate()"
>
  <label class="ui-checkbox__row" [attr.for]="inputId()">
    <!-- Input nativo: sr-only accesible, sin afectar layout -->
    <input
      class="ui-checkbox__input"
      type="checkbox"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [attr.value]="value() ?? null"
      [checked]="checked()"
      [indeterminate]="indeterminate()"
      [disabled]="isInteractionBlocked()"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      (change)="onChange($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />

    <!-- Caja visual: ambos iconos SIEMPRE en el DOM, CSS controla la visibilidad -->
    <span class="ui-checkbox__box" aria-hidden="true">
      <svg class="ui-checkbox__icon ui-checkbox__icon--check" width="10" height="8" viewBox="0 0 10 8" fill="none">
        <path d="M1 4l3 3 5-6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="ui-checkbox__icon ui-checkbox__icon--dash" width="10" height="2" viewBox="0 0 10 2" fill="none">
        <path d="M1 1h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </span>

    @if (!boxOnly()) {
      <span class="ui-checkbox__content">
        @if (label()) {
          <span class="ui-checkbox__label">
            {{ label() }}
            @if (showRequirement()) {
              <span
                class="ui-checkbox__requirement"
                [class.ui-checkbox__requirement--error]="invalid() && required()"
                aria-hidden="true"
              >
                {{ requirementText() }}
              </span>
            }
          </span>
        }
        @if (description()) {
          <span class="ui-checkbox__description" [id]="inputId() + '-desc'">{{ description() }}</span>
        }
      </span>
    }
  </label>

  @if (message() && invalid() && showMessage()) {
    <p class="ui-checkbox__message" [id]="messageId()" role="alert">
      {{ message() }}
    </p>
  }
</div>
